import { CashbackAutoEnrollmentRepository } from "../domain/CashbackAutoEnrollmentRepository"
import { createCashbackApiAutoEnrollmentRepository } from "../infrastructure/ApiCashbackAutoEnrollmentRespository"


export const CashbackRepositoryAPI = (): CashbackAutoEnrollmentRepository => {
  return createCashbackApiAutoEnrollmentRepository()
}